
<div class="component-container">
    <div class="container">
        <!-- Page Header -->
        <div class="page-header">
            <h1 class="page-title">User Management</h1>
            <div class="header-actions">
              
                <button class="btn btn-primary" id="addUserBtn" (click)="openModal()">
                    ➕ Add User
                </button>
            </div>
        </div>

        <!-- Stats Cards -->
        <div class="stats-grid">
            <div class="stat-card">
                <div class="stat-value">{{ userStats?.total }}</div>
                <div class="stat-label">Total Users</div>
                
            </div>
            <div class="stat-card">
                <div class="stat-value">{{ userStats?.active }}</div>
                <div class="stat-label">Active Users</div>
                
            </div>
            <div class="stat-card">
                <div class="stat-value">{{ userStats?.disabled }}</div>
                <div class="stat-label">Disabled Users</div>
            
            </div>
            <div class="stat-card">
                <div class="stat-value">{{ userStats?.verified }}</div>
                <div class="stat-label">Verified Users</div>
                
            </div>
        </div>

        <!-- Controls Bar -->
        <div class="controls-bar">
            <div class="search-filters">
                <div class="search-box">
                    <input type="text" class="search-input" [(ngModel)]="search" placeholder="Search users..." id="searchInput" (input)="searchUsers()">
                    <span class="search-icon">🔍</span>
                </div>
                
                <select class="filter-select" id="statusFilter" [(ngModel)]="statusFilter">
                    <option [value]="''">All Status</option>
                    <option [value]="'active'">Active</option>
                    <option [value]="'verified'">Verified</option>
                    <option [value]="'disabled'">Disabled</option>
                </select>
                
                <select class="filter-select" id="roleFilter" [(ngModel)]="roleFilter">
                    <option [value]="''">All Roles</option>
                    <option [value]="'admin'">Admin</option>
                    <option [value]="'manager'">Manager</option>
                    <option [value]="'driver'">Driver</option>
                    <option [value]="'clerk'">Clerk</option>
                </select>
                
                <button class="btn btn-secondary" id="clearFilters" (click)="clearSearchFilter()">Clear Filters</button>
            </div>
            
            <div class="bulk-actions">
                <span id="selectedCount" [ngStyle]="{'display': getSelectedCount() !== 0 ? 'block' : 'none'}">{{ getSelectedCount() || 0 }} selected</span>
                <select class="bulk-actions-dropdown" id="bulkActionsSelect" [ngStyle]="{'display': getSelectedCount() !== 0 ? 'block' : 'none'}" [(ngModel)]="action">
                    <option [value]="''">Bulk Actions</option>
                    <option [value]="'enable'">Enable Selected</option>
                    <option [value]="'disable'">Disable Selected</option>
                    <option [value]="'delete'">Delete Selected</option>
                    <option [value]="'export'">Export Selected</option>
                </select>
                <button class="btn btn-secondary" id="applyBulkAction" [ngStyle]="{'display': getSelectedCount() !== 0 ? 'block' : 'none'}" (click)="applyBulkAction()">Apply</button>
            </div>
        </div>

        <!-- Users Table -->
        <div class="users-table-container">
            <table class="users-table">
                <thead>
                    <tr>
                        <th>
                            <input type="checkbox" class="checkbox" id="selectAll" (click)="selectAll()" [(ngModel)]="bulkAction">
                        </th>
                        <th>User</th>
                        <th>Role</th>
                        <th>Disabled</th>
                        <th>Last Login</th>
                        <th>Created</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody id="usersTableBody">
                    <tr *ngFor="let user of page.data; let i = index;">
                        <td><input type="checkbox" class="checkbox user-checkbox" data-user-id="i" [(ngModel)]="user.selected"></td>
                        <td>
                            <div class="user-info">
                                <div class="user-avatar">{{ getAvatar(user) }}</div>
                                <div class="user-details">
                                    <div class="user-name">{{ user.username }}</div>
                                    <div class="user-email">{{ user.email }}</div>
                                </div>
                            </div>
                        </td>
                        <td>
                            <span class="role-pill role-admin">{{ user.role }}</span>
                        </td>
                        <td>
                            <span class="status-pill status-active">{{ user.disabled }}</span>
                        </td>
                        <td>2 hours ago</td>
                        <td>Jan 15, 2024</td>
                        <td>
                            <div class="action-buttons">
                                <button class="action-btn action-edit" (click)="editUser(i)" matTooltip="Edit">✏️</button>
                                <button class="action-btn action-disable" (click)="toggleUserStatus(i)" matTooltip="Disable">🚫</button>
                                <button class="action-btn action-delete" (click)="deleteUser(i)" matTooltip="Delete">🗑️</button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        
    </div>
    <!-- Pagination -->
    <div class="paginator">
         <mat-paginator #paginator
        *ngIf="page.data.length !== 0"
        (page)="handlePageEvent($event)"
        [length]="page.totalItems"
        [pageSize]="params.size"
        [showFirstLastButtons]="true"
        [pageSizeOptions]="pageSizeOptions"
        [pageIndex]="page.currentPage"
        aria-label="Select page">
    </mat-paginator>

    </div>
   

    <!-- User Modal -->
    <div class="modal" id="userModal" [ngStyle]="{'display': modal ? 'block' : 'none'}">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title" id="modalTitle" (click)="openModal()">{{ modalText }}</h2>
                <button class="modal-close" (click)="closeModal()">&times;</button>
            </div>
            <div class="modal-body">
                <form id="userForm">
                    <!--
                    <div class="form-row">
                        <div class="form-group">
                            <label class="form-label">First Name</label>
                            <input type="text" class="form-input" name="firstName" required>
                        </div>
                        <div class="form-group">
                            <label class="form-label">Last Name</label>
                            <input type="text" class="form-input" name="lastName" required>
                        </div>
                    </div>
                    -->
                    <div class="form-group">
                        <label class="form-label">Username</label>
                        <input type="text" class="form-input" name="username" [(ngModel)]="selectedUser.username" required (input)="checkUsernameExists()">
                    </div>
                    
                    <div class="form-group">
                        <label class="form-label">Email Address</label>
                        <input type="email" class="form-input" name="email" [(ngModel)]="selectedUser.email" required (input)="checkEmailExists()">
                    </div>

                    <div class="form-group">
                        <label class="form-label">Password</label>
                        <input type="text" class="form-input" name="password" placeholder="password" [(ngModel)]="selectedUser.password">
                    </div>

                    <div class="form-group">
                        <label class="form-label">Confirm Password</label>
                        <input type="text" class="form-input" name="confirm-password" [(ngModel)]="selectedUser.confirmPassword">
                    </div>
                    
                    <div class="form-row">
                        <div class="form-group">
                            <label class="form-label">Role</label>
                            <select class="form-select" name="role" [(ngModel)]="selectedUser.role" required>
                                <option [value]="''">Select Role</option>
                                <option [value]="'admin'">Admin</option>
                                <option [value]="'manager'">Manager</option>
                                <option [value]="'driver'">Driver</option>
                                <option [value]="'clerk'">Clerk</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group">
                            <label class="form-label">Disabled</label>
                            <mat-slide-toggle name="disabled" [(ngModel)]="selectedUser.disabled">{{ selectedUser.disabled }}</mat-slide-toggle>
                        </div>
                        <div class="form-group">
                            <label class="form-label">Email Verified</label>
                            <mat-slide-toggle name="verified" [(ngModel)]="selectedUser.verified">{{ selectedUser.verified }}</mat-slide-toggle>
                        </div>
                    </div>
                
                    
                    <div class="form-group">
                        <label class="form-label">Department</label>
                        <select class="form-select" id="department">
                            <option value="">Select Department</option>
                            <option value="warehouse">Warehouse</option>
                            <option value="sales">Sales</option>
                            <option value="management">Management</option>
                            <option value="it">IT</option>
                            <option value="finance">Finance</option>
                        </select>
                    </div>
                    
                    <div class="form-group">
                        <label class="form-label">Permissions</label>
                        <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px; margin-top: 10px;">
                            <label style="display: flex; align-items: center; gap: 8px;">
                                <input type="checkbox" class="checkbox" id="permInventory">
                                <span>Inventory Management</span>
                            </label>
                            <label style="display: flex; align-items: center; gap: 8px;">
                                <input type="checkbox" class="checkbox" id="permOrders">
                                <span>Order Management</span>
                            </label>
                            <label style="display: flex; align-items: center; gap: 8px;">
                                <input type="checkbox" class="checkbox" id="permReports">
                                <span>Reports & Analytics</span>
                            </label>
                            <label style="display: flex; align-items: center; gap: 8px;">
                                <input type="checkbox" class="checkbox" id="permUsers">
                                <span>User Management</span>
                            </label>
                            <label style="display: flex; align-items: center; gap: 8px;">
                                <input type="checkbox" class="checkbox" id="permSettings">
                                <span>System Settings</span>
                            </label>
                            <label style="display: flex; align-items: center; gap: 8px;">
                                <input type="checkbox" class="checkbox" id="permSuppliers">
                                <span>Supplier Management</span>
                            </label>
                        </div>
                    </div>
                </form>
                
                <!-- Activity Log Section (for edit mode) -->
                 <!--
                <div id="activitySection" [ngStyle]="{'display': modal ? 'block' : 'none'}">
                    <h3 style="margin: 30px 0 15px 0; color: var(--accent-primary);">Recent Activity</h3>
                    <div class="activity-log">
                        <div class="activity-item">
                            <div class="activity-icon login">🔑</div>
                            <div class="activity-content">
                                <div class="activity-title">User logged in</div>
                                <div class="activity-time">2 hours ago</div>
                            </div>
                        </div>
                        <div class="activity-item">
                            <div class="activity-icon update">✏️</div>
                            <div class="activity-content">
                                <div class="activity-title">Profile updated</div>
                                <div class="activity-time">1 day ago</div>
                            </div>
                        </div>
                        <div class="activity-item">
                            <div class="activity-icon logout">🚪</div>
                            <div class="activity-content">
                                <div class="activity-title">User logged out</div>
                                <div class="activity-time">2 days ago</div>
                            </div>
                        </div>
                        <div class="activity-item">
                            <div class="activity-icon error">⚠️</div>
                            <div class="activity-content">
                                <div class="activity-title">Failed login attempt</div>
                                <div class="activity-time">3 days ago</div>
                            </div>
                        </div>
                    </div>
                </div>
                -->
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="closeModal()">Cancel</button>
                <button type="submit" class="btn btn-primary" form="userForm" id="saveUserBtn" (click)="saveUser()">Save User</button>
            </div>
        </div>
    </div>
    </div>